import { FileChartColumn } from "lucide-react";
import type { JSX } from "react";

import { Sheet, SheetBody, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import type { ReportPointer, ReportRevisionRead } from "@/lib/reports";

import { ReportReader } from "./ReportReader";

interface ExpandedReportReaderProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  sessionId: string;
  pointer: ReportPointer;
  expanded: boolean;
  onModify: (read: ReportRevisionRead) => void;
  onOpenRevision: (pointer: ReportPointer) => void;
}

export function ExpandedReportReader({
  open,
  onOpenChange,
  sessionId,
  pointer,
  expanded,
  onModify,
  onOpenRevision,
}: ExpandedReportReaderProps): JSX.Element {
  return (
    <Sheet open={open} onOpenChange={onOpenChange} ariaLabel="Informe ejecutivo">
      <SheetContent
        className={expanded ? "w-full sm:max-w-[96vw]" : "w-full sm:max-w-2xl"}
        onClose={() => onOpenChange(false)}
        side="right"
      >
        <SheetHeader>
          <div className="flex items-center gap-2">
            <FileChartColumn aria-hidden="true" className="size-4 text-muted-foreground" />
            <SheetTitle>Informe</SheetTitle>
          </div>
        </SheetHeader>
        <SheetBody className="bg-background p-0">
          <ReportReader
            mode={expanded ? "expanded" : "dock"}
            onModify={onModify}
            onOpenRevision={onOpenRevision}
            pointer={pointer}
            sessionId={sessionId}
          />
        </SheetBody>
      </SheetContent>
    </Sheet>
  );
}
